import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'
import viAxiosError from './axios-error.vi.json'
import enAxiosError from './axios-error.en.json'

// Registers this module's `services` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'services', vi)
i18n.addResourceBundle('en', 'services', en)
// API errors of this module; `true, false` never overwrites shared keys.
i18n.addResourceBundle('vi', 'axios-error', viAxiosError, true, false)
i18n.addResourceBundle('en', 'axios-error', enAxiosError, true, false)
